export const darkTheme = {
  colors: {
    background: '#0b1221',
    primary: '#4F46E5',
    text: '#E5E7EB',
    accent: '#9CA3AF',
    cardBackground: 'rgba(21, 28, 48, 0.7)',
    cardBorder: 'rgba(79, 70, 229, 0.15)',
  },
  fonts: {
    main: "'Inter', 'Roboto', sans-serif",
  },
};

export const lightTheme = {
  colors: {
    background: '#FFFFFF',
    primary: '#4F46E5',
    text: '#111827',
    accent: '#6B7280',
    cardBackground: 'rgba(255, 255, 255, 0.9)',
    cardBorder: 'rgba(79, 70, 229, 0.12)',
  },
  fonts: {
    main: "'Inter', 'Roboto', sans-serif",
  },
};
